import { useState } from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Card,
  CardHeader,
  CardBody,
  useColorModeValue,
} from "@chakra-ui/react";
import BreadCrumbMaker from "../../../components/BreadCrumbMaker";

const TermsAndConditions = () => {
  const bgColor = useColorModeValue("white", "gray.800");

  const breadcrumbItems = [
    { title: "Operations Setup", link: "/management" },
    { title: "Terms and Conditions", link: "/management/terms-and-conditions" },
  ];

  return (
    <Container maxW="container.xl" py={6}>
      <BreadCrumbMaker items={breadcrumbItems} />
      <Heading size="lg" mb={6}>
        Terms and Conditions
      </Heading>

      <VStack spacing={4} align="stretch">
        <Card bg={bgColor}>
          <CardHeader>
            <Heading size="md">Terms & Conditions Management</Heading>
          </CardHeader>
          <CardBody>
            <Text color="gray.500">
              Terms and conditions management will be available here. This
              section is under development.
            </Text>
          </CardBody>
        </Card>
      </VStack>
    </Container>
  );
};

export default TermsAndConditions;
